/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    bannerContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '0px',
        marginBottom: '15px',
        color: theme.palette.primary,
        backgroundColor: '#FFFFFF',
    },
    imgContainer: {
        '& img': {
            width: '100%',
            display: 'block',
        },
    },
}));

const MobileRecipientBookBanner = ({ bannerData }) => {
    const classes = useStyles();
    return (
        <div className={classes.bannerContainer}>
            <div className={classes.imgContainer}>
                {bannerData?.alert_icon_mobile ? <img src={bannerData.alert_icon_mobile?.url} alt="add reminders" /> : null}
            </div>
        </div>
    )
}

export default MobileRecipientBookBanner;